(function() {
       'use strict';

       angular.module('quantixApp').controller('withdrawnListController',
    		   withdrawnListController);

       withdrawnListController.$inject = [ '$scope', '$http', '$timeout', 'ClientListService','GenericServiceNew','RatingListService','PortfolioService'];

       function withdrawnListController($scope, $http, $timeout, ClientListService, GenericServiceNew, RatingListService,PortfolioService) {
    	   var gridData='';
    		var vm = this;
    		$scope.innertbstId = 1;
    		$scope.currentbstId = 1;
    		$scope.ratingAgencyData = [];
    		$scope.ratingScaleShort = [];
    		$scope.ratingScaleLong = [];
    		$scope.ratingScaleData=[];
    	   $scope.showHideFilter = false;
    	   vm.toDate = '';
			vm.fromDate = '';
			
			
   		$scope.filterCriteriaFlag = {
                   showHideVar: true
               }
   		$scope.showResult = {
                   showHideResult: false
               }
   		
		$('.toptabs ul li a').click(function() {
			
			$('.toptabs ul li a').removeClass("active");
			$(this).addClass("active");
		});
   		
   		$scope.setInnerTabSetData = function(tabId){
   			$scope.innertbstId = tabId;
   		}
   		
   		
   		$scope.fromDate = new Date();
		$scope.toDate = new Date();
		$scope.startMaxDate = new Date();
		$scope.endMaxDate = new Date();

		$scope.popup1 = {
			opened : false
		};
		$scope.popup2 = {
			opened : false
		};

		$scope.open1 = function($event) {
			$scope.popup1.opened = true;
		
		};
		$scope.open2 = function($event) {
			$scope.popup2.opened = true;
			
		};
		
		$scope.$watch('fromDate', function() {

			if (!$scope.fromDate) {
				return;
			}
			if (!$scope.startMaxDate || $scope.startMaxDate > $scope.fromDate) {
				$scope.endMaxDate = new Date();
			} else {
				$scope.startMaxDate = $scope.fromDate;
			}
			$scope.fromDate = $scope.fromDate;

		});

		$scope.$watch('misReport.toDate', function() {

			if (!$scope.toDate) {
				return;
			}
			if (!$scope.endMaxDate || ($scope.endMaxDate > $scope.fromDate)) {
				// $scope.endMaxDate = $scope.misReport.toDate;
			} else {
				$scope.startMaxDate = $scope.toDate;
			}
			$scope.toDate = $scope.toDate;
		});
   		
		$scope.markAll = {
				checked : false
			};
			$scope.markAll1 = {
				checked : false
			};
			
			$scope.getRatingScales = function() {
				$scope.mergeArray = [];
				if ($scope.ratingScaleData.length == 0) {
					PortfolioService.getRatingScaleMasterList().then(
							function(data) {
								$scope.ratingScaletype = data;
								
								angular.forEach(data, function(value, key) {
									
									if (key === 'LongTerm') {
										$scope.ratingScaleLong = value;
										$scope.issuerTermLongRating  = value;
									
									} else if (key === 'ShortTerm') {
										$scope.ratingScaleShort = value;
										$scope.issuerRatingTermsRating = value;
									
										// $scope.mergeArray.concat(value);

									}
									/*
									 * $scope.mergeArray = $scope.ratingScaleLong
									 * .concat($scope.ratingScaleShort);
									 */
								});
								
								
							}, function(error) {
								
							});
				}
			}
			$scope.changeRatingType = function(markAll, markAll1, type) {
				if (type == 'shortTerm') {

					if (markAll) {
						angular.forEach($scope.ratingScaleShort,
								function(val, key) {
									val.chekced = true;
								});
					} else {
						angular.forEach($scope.ratingScaleShort,
								function(val, key) {
									val.chekced = false;
								});
					}

				} else if (type == 'longTerm') {

					if (markAll1) {
						angular.forEach($scope.ratingScaleLong, function(val, key) {
							val.chekced = true;
						});
					} else {
						angular.forEach($scope.ratingScaleLong, function(val, key) {
							val.chekced = false;
						});
					}
				}

			}
			
			$scope.markAll2 = {
					check : false
				};
			
			$scope.changeRatingTypeForIssuerRating = function(markAll2, type) {
			
				if(type == 'issuerRating'){
					$scope.markAll.checked = false;
					$scope.markAll1.checked = false;
					
					angular.forEach($scope.ratingScaleShort, function(val, key) {
						val.chekced = false;
					});
					angular.forEach($scope.ratingScaleLong, function(val, key) {
						val.chekced = false;
					});
					
					$scope.enableMe = true;
					if(markAll2){
						angular.forEach($scope.issuerTermLongRating, function(val, key) {
							val.check = true;
							// alert(val.chekced);
						});
						
						angular.forEach($scope.issuerRatingTermsRating, function(val, key) {
							val.check = true;
							// alert(val.chekced);
						});
						
					}else {
						$scope.issuerRatings="";
						$scope.enableMe = false;
						angular.forEach($scope.issuerTermLongRating, function(val, key) {
							val.check = false;
						});
						
						angular.forEach($scope.issuerRatingTermsRating, function(val, key) {
							val.check = false;
						});
					}
				}

			}
			
			// disable long term and short term filter when user checked issuer rating
			$scope.disableFunc = function(){
				
				
				$scope.markAll.checked = false;
				$scope.markAll1.checked = false;
				
				angular.forEach($scope.ratingScaleShort, function(val, key) {
					val.chekced = false;
				});
				angular.forEach($scope.ratingScaleLong, function(val, key) {
					val.chekced = false;
				});
			
				for ( var i in $scope.issuerTermLongRating) {
					if ($scope.issuerTermLongRating[i].check == true) {
						$scope.flagOfissuerLongTerm = true;
						break;
					}else{
						
						$scope.flagOfissuerLongTerm = false;
					}
				}
				
				for ( var i in $scope.issuerRatingTermsRating) {
					if ($scope.issuerRatingTermsRating[i].check == true) {
						$scope.flagOfissuerShortTerm = true;
						break;
					}else{
						
						$scope.flagOfissuerShortTerm = false;
					}
				}
				
				if($scope.flagOfissuerLongTerm || $scope.flagOfissuerShortTerm){
					
					$scope.enableMe = true;
				}else{
					$scope.enableMe = false;
				}
				
			}
   		
   		$scope.openInputFilterContainer = function(){
   			$('.toptabsec ul li a').click(function(e) {
				e.preventDefault();
				$('.toptabsec ul li a').removeClass("active");
				$(this).addClass("active");
			});
   			 if ($scope.filterCriteriaFlag.showHideVar) {
   				 $scope.showHideFilter = true;
   			$scope.filterCriteriaFlag = {
   	                    showHideVar: false
   	                }
   			$scope.showResult = {
   	                    showHideResult: true
   	                }
   			 }else {
   				 $scope.showHideFilter = false;
   	                $scope.filterCriteriaFlag = {
   	                    showHideVar: true
   	                }
   	           
   	                $scope.showResult = {
   	                    showHideResult: true
   	                }

   	            }
   		}
   		
   		
   		// company search filter
   		
		$scope.searchCnameForWithdrawnRating = function(typedthings) {
			// when $watch is executing companyCode is null , it will be get
			// after selecting a compnay
			$scope.companyCode = "";
			if (typedthings == "cleanData") {
				$scope.companies = null;
			} else {
				GenericServiceNew
						.getCompaniesListByNameNew(typedthings,
								"CreditRatingList")
						.then(
								function(data) {
									$scope.companies = data;
									
									if ($scope.companies.length == 0) {
										$scope.ifError = true;
										$scope.errorMessages = "Please search the appropriate company!";
//										AlertService
//												.error("Please search the appropriate company!");
									}
									else{
									$scope.ifError = false;
									$scope.errorMessages = "";
									}
									
								},
								function(errordata) {
									$scope.ifError = true;
									$scope.errorMessages = "Please search the appropriate company!";
									AlertService
											.error("Error while searching company!");
								});
			}

		}
		
		// filter for rating agency
		
		$scope.getRatingAgencyMasterList = function() {

			if ($scope.ratingAgencyData.length == 0) {
				RatingListService.getRatingAgencyMasterList().then(
						function(data) {
							$scope.ratingAgencyData = data;
							
							angular.forEach($scope.ratingAgencyData, function(val, key) {
								if(val.labelName != 'CRISIL'){
								val.chekced = false;
								}else{
									val.chekced = true;
								}
							});
							
							$scope.reSetWithdrawnFilter();

						}, function(error) {
							
						});
			}

		}
		
		$scope.selectAll = {
				checked : false
			};
			$scope.changeAgencies = function(selectAll) {
				if (selectAll) {
					angular.forEach($scope.ratingAgencyData, function(val, key) {
						val.chekced = true;
					});
				} else {
					angular.forEach($scope.ratingAgencyData, function(val, key) {
						val.chekced = false;
					});
				}

			}
			
			//Date validation
			
			   $scope.checkErr = function (fromDate, toDate) {
	            $scope.errMessage = '';
	            $scope.fromDateTrue = false;
	            $scope.toDateTrue = false;
	            var curDate = new Date();
	            if((fromDate != '' && fromDate != undefined) && (toDate!='' && toDate != undefined)){
	            if (new Date(fromDate) > new Date(toDate)) {
	            	$scope.toDateTrue = false;
	                alert("todate should be greater than fromDate.");
	                return false;
	            }else{
	            	$scope.toDateTrue = true;
	            	
	            	// Added Bhadra For Task Id: 49781 
	                 $scope.fromDateTrue=true;
	            }
	            
	            if (new Date(fromDate) < curDate) {
	            	$scope.fromDateTrue = true;
	            	$scope.toDateTrue = true;
	            	
	            }else{
	            	 $scope.fromDateTrue = false;
	            	
		                $scope.errMessage = 'fromDate should not be before today.';
		                alert("fromDate should not be before today.");
		                return false;
	            }
	            }else{
	            	$scope.fromDateTrue = false;
	            	$scope.toDateTrue = false;
	            }
	        };
    	   
    	   $scope.withdrawnListGridCompletion = function (event) {
     		  gridData = event.target;
     		  gridData.validateNow();
          };
    	   
    		$scope.getWithdrawnRatingsList = function(){
    			
    			$scope.checkErr(vm.fromDate,vm.toDate);
    			
    			// rating Agency filter 
    			if ($scope.ratingAgencyData != undefined) {
    				$scope.selectedratingagencies = [];
    				
    	
    			var k=0;
    				for(var j=0; j< $scope.ratingAgencyData.length;j++){
    					if($scope.ratingAgencyData[j].chekced){
    						k++;
    					}
    					
    				}
    			if(k == 0){
    				for ( var i in $scope.ratingAgencyData) {
    				if ($scope.ratingAgencyData[i].name == 'CRISIL Ltd.') 
    					$scope.ratingAgencyData[i].chekced = true;
    			
    				}
    			}
    				for ( var i in $scope.ratingAgencyData) {
    					 if ($scope.ratingAgencyData[i].chekced == true) {
    						
    						$scope.selectedratingagencies
    								.push($scope.ratingAgencyData[i]);
    					}
    				}

    				$scope.selectedratingagenciesTemp = $scope.selectedratingagencies
    						.map(function(element) {
    							return "<" + String(element.labelName) + "<"
    						})
    			}
    			
    			// rating type filter
    			// for ShortTerm Filter
    			if ($scope.ratingScaleShort != undefined) {
    				$scope.selectedShortTerm = [];
    				for ( var i in $scope.ratingScaleShort) {
    					if ($scope.ratingScaleShort[i].chekced == true) {
    						$scope.selectedShortTerm
    								.push($scope.ratingScaleShort[i]);
    					}
    				}

    				$scope.selectedShortTermTemp = $scope.selectedShortTerm
    						.map(function(element) {
    							return "<" + String(element.name) + "<"
    						})
    			}

    			// for longTerm filter
    			if ($scope.ratingScaleLong != undefined) {
    				$scope.selectedLongTerm = [];
    				for ( var i in $scope.ratingScaleLong) {
    					if ($scope.ratingScaleLong[i].chekced == true) {
    						$scope.selectedLongTerm.push($scope.ratingScaleLong[i]);
    					}
    				}

    				$scope.selectedLongTermTemp = $scope.selectedLongTerm
    						.map(function(element) {
    							return "<" + String(element.name) + "<"
    						})
    			}
    			
    			// for Date Range
    			
    			if($scope.fromDateTrue == true && $scope.toDateTrue == true){
    				$scope.fromDateTemp = vm.fromDate;
    				$scope.toDateTemp = vm.toDate
    			}else{
    				$scope.fromDateTemp = '';
    				$scope.toDateTemp = '';
    			}
    			
    			
    			$scope.searchCompany=vm.searchCompanies;
    			
    			if(vm.searchCompanies == undefined){
    				$scope.searchCompany=' ';
    			}
    			
    			// for issuer rating filter
    			
    			if ($scope.issuerTermLongRating != undefined) {
    				$scope.selectedIssuerLongTerm = [];
    				for ( var i in $scope.issuerTermLongRating) {
    					if ($scope.issuerTermLongRating[i].check == true) {
    						$scope.issuerRatings = "issuerRating";
    						$scope.selectedIssuerLongTerm
    								.push($scope.issuerTermLongRating[i]);
    					}
    				}

    				$scope.selectedIssuerLongTermTemp = $scope.selectedIssuerLongTerm
    						.map(function(element) {
    							return "<" + String(element.name) + "<"
    						})
    			}

    			
    			if ($scope.issuerRatingTermsRating != undefined) {
    				$scope.selectedissuerShortTerm = [];
    				for ( var i in $scope.issuerRatingTermsRating) {
    					if ($scope.issuerRatingTermsRating[i].check == true) {
    						$scope.issuerRatings = "issuerRating";
    						$scope.selectedissuerShortTerm.push($scope.issuerRatingTermsRating[i]);
    					}
    				}

    				$scope.selectedIssuerShortTermTemp = $scope.selectedissuerShortTerm
    						.map(function(element) {
    							return "<" + String(element.name) + "<"
    						})
    			}
    			
     			var searchText = '';
     			searchText = "{'ratingAgency' : '"
					+ $scope.selectedratingagenciesTemp
					+ "', 'nameOfCompany' : '" + $scope.searchCompany
					+ "', 'shortTerm' : '" + $scope.selectedShortTermTemp
					+ "', 'longTerm' : '" + $scope.selectedLongTermTemp
					+ "', 'issuerShortTerm' : '" + $scope.selectedIssuerShortTermTemp
					+"', 'issuerLongTerm' : '" + $scope.selectedIssuerLongTermTemp
					+ "', 'fromDate' : '" + $scope.fromDateTemp
					+ "', 'issuerRatingFlag' : '" + $scope.issuerRatings
					+ "', 'toDate' : '" + $scope.toDateTemp + "'}";
    	searchText = searchText.replace(/\'/g, "\"");
    	searchText = searchText.replace(/\</g, "\'")
    	$scope.inputDataTemp = searchText;
    	$scope.finalWithdrawnSearchData = searchText;
     			ClientListService.getWithdrawnList(searchText).then(
     					function(result) {
     						$scope.gridDataForWithdrawn = {
     								dataProvider : result,
     								delegate : $scope
     							};
     					});
     			
     		}
    		
    		$scope.reSetWithdrawnFilter = function(){
    	    	   vm.toDate = '';
    				vm.fromDate = '';
    				vm.searchCompanies=' ';
    				angular.forEach($scope.ratingAgencyData, function(val, key) {
    					val.chekced = false;
    				});
    				angular.forEach($scope.ratingScaleShort, function(val, key) {
    					val.chekced = false;
    				});
    				angular.forEach($scope.ratingScaleLong, function(val, key) {
    					val.chekced = false;
    				});
    				angular.forEach($scope.issuerTermLongRating, function(val, key) {
    					val.check = false;
    				});
    				
    				angular.forEach($scope.issuerRatingTermsRating, function(val, key) {
    					val.check = false;
    					
    				});
    				
    				$scope.selectAll.checked = false;
    				$scope.innertbstId = 1;
    				$scope.selectedIssuerShortTermTemp = '';
    				$scope.selectedIssuerLongTermTemp = '';
    				$scope.issuerRatings ="";
    				$scope.getWithdrawnRatingsList();
    		}
    		
    		$scope.withdrawnListExport = function(){

				$http({
					url : 'api/adminScreen/withdrawnListExcelExportData',
					method : 'POST',
					data : $scope.inputDataTemp,
					responseType : 'arraybuffer'
				})
						.success(

								function(response) {
								
									var isIE = false || !!document.documentMode;
									$scope.response = response;
									var blob = new Blob(
											[ response ],
											{
												type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
											});
									if (isIE) {

										window.navigator.msSaveOrOpenBlob(blob,
												'Withdrawn List.xlsx');
									} else {

										var anchor = angular.element('<a/>');
										var blob = new Blob([ response ], {
											type : 'application/vnd.ms-excel'
										})
										var objectUrl = (window.URL || window.webkitURL)
												.createObjectURL(blob);
										anchor.css({
											display : 'none'
										});
										// Make sure it's not visible
										angular.element(document.body).append(
												anchor); // Attach to document
										anchor.attr({
											href : objectUrl,
											target : '_self',

											download : 'Withdrawn List.xlsx'
										})[0].click();

										anchor.remove();

									}

								})
				

			
    			
    		}
    		
    		$scope.getRatingScales();
    	   
    		$scope.getRatingAgencyMasterList();
    		
    	  // $scope.getWithdrawnList();
       }


})();